import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { useAxeptio } from '~/composables/_next/useAxeptio';
export default defineNuxtPlugin(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  var _useNuxt2App, $config, $trackers, snapKey, _useAxeptio, onConsent;
  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _useNuxt2App = useNuxt2App(), $config = _useNuxt2App.$config, $trackers = _useNuxt2App.$trackers;
        snapKey = $config.public.pixelSnapKey;
        if (snapKey) {
          _context2.next = 4;
          break;
        }
        return _context2.abrupt("return");
      case 4:
        _useAxeptio = useAxeptio(), onConsent = _useAxeptio.onConsent; // The snapchat script tag must be added immediately for @nuxtjs/partytown to
        // properly copy the library files. This does not enable tracking.
        useHead({
          script: [{
            type: 'text/partytown',
            children: "\n(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()\n{a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};\na.queue=[];var s='script';r=t.createElement(s);r.async=!0;\nr.src=n;var u=t.getElementsByTagName(s)[0];\nu.parentNode.insertBefore(r,u);})(window,document, 'https://sc-static.net/scevent.min.js');\n<!-- End Snap Pixel Code -->\n"
          }]
        });
        onConsent('snap_pixel', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                // Initialize Snap Pixel only after the consent is collected. This can't use partytown
                // because partytown script files will already be generated when this will run.
                if (window.snaptr) {
                  window.snaptr('init', snapKey);
                  $trackers.gtm.pushEvent('library_loaded', {
                    library_name: 'snap_pixel',
                    page_url: window.location.href
                  });
                }
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })));
      case 7:
      case "end":
        return _context2.stop();
    }
  }, _callee2);
})));